import { ColInterface } from "./typing";

export default function Col({ children, className = "", span = 1 }: ColInterface) {
  return <div className={`col-span-${span} ${className}`}>{children}</div>;
}
